// extracted by mini-css-extract-plugin
export default {"room":"ConnectedRoomList_room__XRo30","unvisited":"ConnectedRoomList_unvisited__jMoSK","visited":"ConnectedRoomList_visited__JMFn2","title":"ConnectedRoomList_title__c5H0v"};